import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { TranslateModule } from "@ngx-translate/core";
import { TagInputComponent } from "../tag-input/tag-input.component";
import { Tag } from "../../../api/models/tag";

/**
 * Custom Formly field type for Azure Boards-style tag input.
 * Wraps the TagInputComponent for use in Formly forms.
 *
 * Usage:
 * ```typescript
 * {
 *   key: 'tags',
 *   type: 'tag-input',
 *   props: {
 *     label: 'Tags',
 *     suggestions: availableTags,
 *     placeholder: 'Type to search or add a tag',
 *     allowCreate: true
 *   }
 * }
 * ```
 */
@Component({
  selector: "formly-tag-input",
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, TagInputComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (props.label) {
      <label class="form-label">{{ props.label | translate }}</label>
    }
    <app-tag-input
      [suggestions]="suggestions"
      [placeholder]="props.placeholder || 'Type to search or add a tag'"
      [allowCreate]="props['allowCreate'] !== false"
      [formControl]="formControl"
    ></app-tag-input>
  `,
})
export class TagInputFieldType extends FieldType<FieldTypeConfig> {
  get suggestions(): Tag[] {
    return Array.isArray(this.props["suggestions"])
      ? this.props["suggestions"]
      : [];
  }
}
